export const PROJECT_API_ENUM = {
  BASIC_INFO: 'basic_info',
  USERS: 'users',
  TAGS: 'tags',
  PACKAGES: 'packages',
  DOCUMENT: 'documents',
  SERVICE_HISTORY: 'service_history',
};
Object.freeze(PROJECT_API_ENUM);
